(() => {
  function init() {
    const header = document.querySelector('.pageheader');
    const nav = header?.querySelector('.sc-desktop-nav');
    if (!nav || nav.dataset.scFitReady) return;
    nav.dataset.scFitReady = 'true';
    const row = header.querySelector('.logo-area.container');
    const items = [...nav.querySelectorAll('.sc-desktop-nav__item')];
    let frame;
    function close(item) {
      item.classList.remove('sc-menu-open');
      item.classList.add('sc-menu-closed');
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'false');
    }
    function open(item) {
      items.forEach(other => { if (other !== item) close(other); });
      item.classList.remove('sc-menu-closed');
      item.classList.add('sc-menu-open');
      item.querySelector(':scope > a')?.setAttribute('aria-expanded', 'true');
      fitHeight();
    }
    function fitHeight() {
      const bottom = row.getBoundingClientRect().bottom;
      const viewportBottom = window.visualViewport ? visualViewport.height + visualViewport.offsetTop : innerHeight;
      row.style.setProperty('--sc-menu-height', `${Math.max(80, viewportBottom - bottom - 16)}px`);
    }
    function fit() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        // Measure natural desktop content, not the collapsed drawer dimensions.
        document.documentElement.classList.remove('sc-drawer-layout');
        const style = getComputedStyle(row);
        const gap = parseFloat(getComputedStyle(nav).columnGap) || 0;
        const links = [...nav.querySelectorAll(':scope > .sc-desktop-nav__item > a')];
        const navWidth = links.reduce((sum, link) => sum + link.getBoundingClientRect().width, 0) + gap * (links.length - 1);
        const logoWidth = header.querySelector('.logo')?.getBoundingClientRect().width || 180;
        const controls = header.querySelector('.logo-area__right__inner').getBoundingClientRect().width;
        const required = navWidth + 2 * Math.max(logoWidth * 1.15, controls, 155) + 48 + parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        const drawer = innerWidth < 1024 || required > row.clientWidth;
        document.documentElement.classList.toggle('sc-drawer-layout', drawer && innerWidth >= 768);
        if (!drawer && document.body.classList.contains('reveal-mobile-nav')) {
          document.body.classList.remove('reveal-mobile-nav','reveal-mobile-nav--revealed','enable-mobile-nav-transition');
        }
        if (drawer) items.forEach(close);
        fitHeight();
      });
    }
    items.forEach((item, index) => {
      const panel = item.querySelector('.sc-desktop-mega');
      if (!panel) return;
      const link = item.querySelector(':scope > a');
      panel.removeAttribute('role'); // ordinary navigation links, not an ARIA application menu
      panel.id = `sc-desktop-panel-${index}`;
      link.setAttribute('aria-controls', panel.id);
      link.setAttribute('aria-expanded', 'false');
      item.addEventListener('pointerenter', e => { if (e.pointerType !== 'touch') open(item); });
      item.addEventListener('pointerleave', () => { if (!item.contains(document.activeElement)) close(item); });
      item.addEventListener('focusin', () => open(item));
      item.addEventListener('focusout', e => { if (!item.contains(e.relatedTarget)) close(item); });
      link.addEventListener('pointerdown', e => {
        if (e.pointerType === 'touch') item.dataset.touchWasOpen = String(item.classList.contains('sc-menu-open'));
      });
      link.addEventListener('click', e => {
        if (item.dataset.touchWasOpen === 'false') { e.preventDefault(); open(item); }
        delete item.dataset.touchWasOpen;
      });
      link.addEventListener('keydown', e => {
        if (e.key === 'ArrowDown' || e.key === ' ') { e.preventDefault(); open(item); panel.querySelector('a')?.focus(); }
      });
      item.addEventListener('keydown', e => {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); link.focus(); close(item); }
      });
    });
    document.addEventListener('pointerdown', e => { if (!nav.contains(e.target)) items.forEach(close); });
    const toggle = header.querySelector('button.mobile-nav-toggle');
    let returnFocus;
    const drawerElement = () => document.querySelector('.mobile-navigation-drawer.scmm-drawer');
    const focusable = drawer => [...drawer.querySelectorAll('a[href],button,input,select,[tabindex="0"]')]
      .filter(el => el.getClientRects().length && getComputedStyle(el).visibility !== 'hidden' && !el.disabled);
    function closeDrawer() {
      document.body.classList.remove('reveal-mobile-nav', 'reveal-mobile-nav--revealed', 'enable-mobile-nav-transition');
      toggle?.setAttribute('aria-expanded', 'false');
      drawerElement()?.setAttribute('aria-hidden', 'true');
      returnFocus?.focus({ preventScroll: true });
    }
    // Reuse the custom drawer markup. The legacy opener expects navigation links
    // that this custom drawer no longer contains; it also lacks a focus trap.
    window.addEventListener('click', event => {
      const control = event.target.closest?.('.mobile-nav-toggle');
      if (!control || (!header.contains(control) && !drawerElement()?.contains(control))) return;
      const drawer = drawerElement();
      if (!drawer) return;
      event.preventDefault(); event.stopImmediatePropagation();
      if (document.body.classList.contains('reveal-mobile-nav')) { closeDrawer(); return; }
      returnFocus = control;
      drawer.setAttribute('role', 'dialog');
      drawer.setAttribute('aria-modal', 'true');
      drawer.setAttribute('aria-label', 'Navigation');
      drawer.setAttribute('aria-hidden', 'false');
      toggle?.setAttribute('aria-expanded', 'true');
      document.body.classList.add('enable-mobile-nav-transition', 'reveal-mobile-nav', 'reveal-mobile-nav--revealed');
      window.theme?.manuallyLoadImages?.(drawer);
      focusable(drawer)[0]?.focus({ preventScroll: true });
    }, true);
    document.addEventListener('keydown', event => {
      if (!document.body.classList.contains('reveal-mobile-nav')) return;
      if (event.key === 'Escape') { event.preventDefault(); closeDrawer(); }
      if (event.key === 'Tab') {
        const links = focusable(drawerElement());
        const first = links[0], last = links[links.length - 1];
        if (event.shiftKey && (document.activeElement === first || !drawerElement().contains(document.activeElement))) {
          event.preventDefault(); last?.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first?.focus();
        }
      }
    });
    window.addEventListener('resize', fit, { passive: true });
    window.addEventListener('orientationchange', fit, { passive: true });
    window.addEventListener('scroll', fitHeight, { passive: true });
    window.visualViewport?.addEventListener('resize', fit);
    document.fonts?.ready.then(fit);
    document.fonts?.addEventListener('loadingdone', fit);
    new ResizeObserver(fit).observe(row);
    fit();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
